import React from 'react';
import GabigBannerDE from '../../../../assets/img/gabig-banner-de.webp';
import GabigBannerEN from '../../../../assets/img/gabig-banner-en.webp';
import GabigBannerFR from '../../../../assets/img/gabig-banner-fr.webp';

const GabigBanners = [
  {
    language: 'de',
    img: GabigBannerDE,
    link: 'https://gabig.app/de/purchase?utm_source=app&utm_medium=banner&utm_campaign=bedaya',
  },
  {
    language: 'fr',
    img: GabigBannerFR,
    link: 'https://gabig.app/fr/purchase?utm_source=app&utm_medium=banner&utm_campaign=bedaya',
  },
  {
    language: 'en',
    img: GabigBannerEN,
    link: 'https://gabig.app/de/purchase?utm_source=app&utm_medium=banner&utm_campaign=bedaya',
  },
];

export const GetGabigBanner = ({ code }: { code: string }) => {
  let banner = GabigBanners.find(it => it.language === code);
  if (!banner) {
    banner = GabigBanners.find(it => it.language === 'en')!;
  }
  return (
    <a href={banner.link} style={{ display: 'flex', alignItems: 'center' }}>
      <img src={banner.img} style={{ maxHeight: '200px', border: '1px solid #ccc' }} alt="" />
    </a>
  );
};
